import { useEffect, useState } from "react";
import ConfirmationPopup from '../component/ConfirmationPopup';
import Spinner from "../component/Spinner";
import axiosInstance from "../networking/axiosconfig.js";
import Departmentpopup from "../component/Departmentpopup.js";
import Navbar from './Navbar';
import { Layers, Plus } from 'lucide-react';
import Pagination from '../component/Pagination';

const DepartmentList = () => {
    const [departmentList, setDepartmentList] = useState([]);
    const [filteredEmployees, setFilteredEmployees] = useState([]);
    const [loading, setLoading] = useState(true);
    const [isPopupVisible, setPopupVisible] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [showDepartmentPopup, setShowDepartmentPopup] = useState(false);
    const [searchTerm, setSearchTerm] = useState("");
    const departmentUrl = `/api/departments`;
    const [currentPage, setCurrentPage] = useState(1);
    const itemsPerPage = 15;
    //  Fetch Department List
    useEffect(() => {
        axiosInstance.get(departmentUrl)
            .then((res) => {
                if (res.data && Array.isArray(res.data.data)) {
                    setDepartmentList(res.data.data);
                    setFilteredEmployees(res.data.data);
                } else {
                    console.error('Invalid data format');
                }
            })
            .catch((error) => console.error('Error fetching data:', error))
            .finally(() => setLoading(false));
    }, []);


    //  Handle Delete Click
    const handleDeleteClick = (department_id_PK) => {
        setSelectedId(department_id_PK);
        setPopupVisible(true);
        console.log("depratment id", department_id_PK)
    };

    //  Handle Confirm Delete
    const handleConfirmDelete = async () => {
        if (!selectedId) return;

        try {
            await axiosInstance.delete(`${departmentUrl}/${selectedId}`);
            console.log("Department deleted successfully");

            setDepartmentList(prev => prev.filter(item => item.department_id_PK !== selectedId));
            setPopupVisible(false);
        } catch (error) {
            console.error("Error deleting department:", error);
        }
    };

    useEffect(() => {
        const filtered = departmentList.filter(element =>
            element.department_name.toLowerCase().includes(searchTerm.toLowerCase())
        );
        setFilteredEmployees(filtered);
        setCurrentPage(1);
    }, [searchTerm, departmentList]);
    //  Pagination Logic
    const totalItems = filteredEmployees.length;
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentDesignationList = filteredEmployees.slice(indexOfFirstItem, indexOfLastItem);
    const [popupKey, setPopupKey] = useState(0);

    // handle Add buton
    const handleButtonClick = () => {
        setSelectedId(null);
        setPopupKey(prev => prev + 1);   // ⭐ force new popup
        setShowDepartmentPopup(true);
    };

    // Handle Edit button
    const handleEditClick = (department_id_PK) => {
        setShowDepartmentPopup(false);

        setTimeout(() => {
            setSelectedId(department_id_PK);
            setPopupKey(prev => prev + 1);
            setShowDepartmentPopup(true);
        }, 0);
    };


    return (
        <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
            <Navbar />
            {/* Confirmation Popup */}
            <ConfirmationPopup
                open={isPopupVisible}
                setOpen={setPopupVisible}
                title="Delete"
                message="Are you sure you want to delete this department?"
                confirmText="Delete"
                onConfirm={handleConfirmDelete}
            />
            {showDepartmentPopup && (
                <Departmentpopup
                    key={popupKey}
                    selectedId={selectedId}
                    onClose={() => {
                        setShowDepartmentPopup(false);
                        setSelectedId(null);
                    }}
                />
            )}


            <div className="max-w-7xl mx-auto p-6">
                <div className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-4">
                            <div className="bg-white bg-opacity-20 p-3 rounded-lg">
                                <Layers size={32} />
                            </div>
                            <div>
                                <h1 className="text-3xl md:text-4xl font-bold mb-2">Department List</h1>
                                <h2 className="text-xs md:text-sm ml-1 font-inter ">Welcome to the Department List.</h2>
                            </div>
                        </div>
                        <button
                            onClick={handleButtonClick}
                            className="flex items-center gap-2 px-6 py-3 bg-white text-blue-600 rounded-lg hover:bg-blue-50 transition-colors font-semibold shadow-lg"
                        >
                            <Plus size={20} />
                            <span> Add Department</span>
                        </button>
                    </div>
                </div>
                {/* Department List */}
                <div className="w-full  h-full ">
                    <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden lg:mt-8 mt-6 ml-1 ">
                        <thead className="bg-gradient-to-r from-blue-600 via-blue-700 to-indigo-800 rounded-2xl shadow-2xl p-8 mb-6 text-white">
                            <tr>
                                <th className="py-3 px-4 font-inter text-sm text-left font-semibold text-white" >S.No.</th>
                                <th className="py-3 px-4 font-inter text-sm text-left font-semibold text-white">Name</th>
                                <th className="py-3 px-4 font-inter text-sm font-semibold text-white">Action</th>
                            </tr>
                        </thead>
                        <tbody className="divide-y divide-gray-200">
                            {/* spinner */}
                            {loading ? (
                                <tr>
                                    <td colSpan="3" className="text-center py-12">
                                        <Spinner size={30} color="#3498db" loading={loading} />
                                    </td>
                                </tr>
                            ) : currentDesignationList.length > 0 ? (
                                currentDesignationList.map((dept, index) => (
                                    <tr key={dept.department_id_PK} className="border-b hover:bg-gray-50 text-center">
                                        <td className="px-4 py-4 text-left text-sm font-inter">{index + 1}</td>
                                        <td className="px-4 py-4 text-left text-sm font-inter">{dept.department_name}</td>

                                        <td className="px-4 py-4 text-sm font-inter">
                                            <button
                                                onClick={() => handleEditClick(dept.department_id_PK)}
                                                className="text-blue-600 mr-3 hover:text-text-900 font-inter"
                                            >
                                                Edit
                                            </button>
                                            <button
                                                onClick={() => handleDeleteClick(dept.department_id_PK)}
                                                className="text-red-600 hover:text-red-900 font-inter"
                                            >
                                                Delete
                                            </button>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="3" className="text-center py-6 text-gray-500 font-inter">No departments found.</td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </div>

            <div className="max-w-7xl mx-auto">
                <div className="w-full bg-white rounded-2xl ">
                    <Pagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={currentPage}
                        onPageChange={setCurrentPage}
                    />
                </div>
            </div>
        </div>
    );
};

export default DepartmentList;



